import fb from "@/configs/Firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";

class FirebaseAuthService {
  async signIn(email, password) {
    try {
      return await signInWithEmailAndPassword(fb.auth, email, password);
    } catch (error) {
      throw new Error(error.message);
    }
  }
  async signOut() {
    try {
      return signOut(fb.auth);
    } catch (error) {
      throw new Error(error.message);
    }
  }
}

export default new FirebaseAuthService();
